import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueCookies from 'vue-cookies'

Vue.use(VueI18n) //Vue에게 i18n 을 사용하겠다고 명시


function loadLocaleMessages() {
    // json 파일을 읽어들이기 위한 function
    const requireLang = require.context('@/locales', true, /\.json$/);
    const messages = {};
    // json file read
    for (const file of requireLang.keys()) {
      if (file === './index.js') continue; // index.js 파일 제외
      const path = file.replace(/(\.\/|\.json$)/g, '').split('/');
      path.reduce((o, s, i) => {
        if (o[s]) return o[s];
        o[s] = i + 1 === path.length ? requireLang(file) : {};
        return o[s];
      }, messages);
    }
    return messages;
}

const options = {
    locale: (VueCookies.isKey('KX_POTL_LANG')) ? VueCookies.get('KX_POTL_LANG') : 'ko', // 기본언어 (국문)
    fallbackLocale: 'ko', // 지정한 언어에 번역이 없을 때 보여줄 언어 (영문)
    messages: loadLocaleMessages(),
    silentTranslationWarn: true,
};

export const i18n = new VueI18n(options);